import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import EventCard from '@/components/base/EventCard';
import { events } from '@/mocks/events';
import type { GossipEvent } from '@/types';

export default function PickedTimelines() {
  const picked = events.filter((item) => !item.featured).slice(0, 5) as GossipEvent[];

  return (
    <section id="timelines" className="border-y border-background-200 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <SectionHeading
                kicker="时间线精选"
                title="一条线看完来龙去脉"
                description="每个事件都拆成起点、发酵、回应、结局四个阶段，节点之间标注了时间关系，方便你快速定位事情到底在哪儿拐了弯。"
              />
              <div className="mt-6 space-y-3">
                {[
                  { icon: 'ri-flag-line', text: '起点：事情最初是怎么被提出来的' },
                  { icon: 'ri-fire-line', text: '发酵：讨论在哪一步开始失控' },
                  { icon: 'ri-chat-quote-line', text: '回应：各方在何时给出了什么说法' },
                  { icon: 'ri-checkbox-circle-line', text: '结局：当下形成了怎样的阶段性结果' },
                ].map((row) => (
                  <div key={row.text} className="flex items-start gap-3">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                      <i className={`${row.icon} text-base`} />
                    </span>
                    <p className="pt-1 text-sm leading-relaxed text-foreground-700">{row.text}</p>
                  </div>
                ))}
              </div>
              <Link
                to="/timeline"
                className="mt-8 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-foreground-800"
              >
                进入事件合集
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-4 lg:col-span-8">
            {picked.map((item) => (
              <EventCard key={item.id} event={item} variant="row" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}